var React = require('react');

function UploadIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"ICON_-_Upload","data-name":"ICON - Upload","transform":"translate(1 1.414)"},[React.createElement("path",{"id":"Path_2312","data-name":"Path 2312","d":"M315.394,382.9l5.748-5.747V391.52m5.748-8.621-5.748-5.748","transform":"translate(-309.647 -377.151)","fill":"none","stroke":"#27788c","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Path_10945","data-name":"Path 10945","d":"M309.647,391.519v5.748h22.99v-5.748","transform":"translate(-309.647 -377.151)","fill":"none","stroke":"#27788c","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

UploadIcon.defaultProps = {"width":"24.99","height":"22.53","viewBox":"0 0 24.99 22.53"};

module.exports = UploadIcon;

UploadIcon.default = UploadIcon;
